module.exports = __webpack_public_path__ + "img/osiho.88f7c7ff.png";